<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h2 class="mb-0">Catálogo de Trámites</h2>
      <button class="btn btn-primary" (click)="router.navigate(['/catalogs/create-tramite'])">
        <i class="fa fa-plus"></i> Nuevo Trámite
      </button>
    </div>
    <div class="card-body">
      <!-- Barra de búsqueda y filtros -->
      <div class="row mb-3">
        <div class="col-md-4">
          <input 
            type="text" 
            class="form-control" 
            placeholder="Buscar por nombre o código..." 
            [(ngModel)]="searchValue"
            (ngModelChange)="onSearchChange()"
          />
        </div>
        <div class="col-md-3">
          <select class="form-control" [(ngModel)]="selectedStatus" (ngModelChange)="onStatusChange()">
            <option value="">Todos los estados</option>
            <option value="Activos">Activos</option>
            <option value="Inactivos">Inactivos</option>
          </select>
        </div>
      </div>

      <!-- Tabla de trámites -->
      <div class="table-responsive" *ngIf="!isLoading; else loadingTemplate">
        <table mat-table class="table" matSort (matSortChange)="sortData($event)" [dataSource]="dataSource">
          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="nombre">Nombre del Trámite</th>
            <td mat-cell *matCellDef="let item">{{ item.Form?.FormsCommon?.Name || '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="codigo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="codigo">Código</th>
            <td mat-cell *matCellDef="let item">{{ item.Form?.FormsCommon?.Code || '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="categoria">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="categoria">Categoría</th>
            <td mat-cell *matCellDef="let item">{{ item.Category?.Name || '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="area">
            <th mat-header-cell *matHeaderCellDef>Área</th>
            <td mat-cell *matCellDef="let item">{{ item.Form?.Areas?.Name || '-' }}</td>
          </ng-container>

          <ng-container matColumnDef="tiempoRespuesta">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="tiempoRespuesta">Tiempo de Respuesta</th>
            <td mat-cell *matCellDef="let item">
              {{ formatTime(item.Form?.FormsCommon?.AnswerTime, item.Form?.FormsCommon?.AnswerTimeType) }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let item">
              <span class="badge" [ngClass]="item.Form?.Active ? 'badge-success' : 'badge-secondary'">
                {{ item.Form?.Active ? 'Activo' : 'Inactivo' }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let item">
              <button class="btn btn-sm btn-primary mr-1" (click)="editTramite(item)">
                <i class="fa fa-edit"></i>
              </button>
              <button class="btn btn-sm btn-danger" (click)="deleteTramite(item)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div class="text-center mt-3" *ngIf="filteredTramites.length === 0">
          <p>No se encontraron trámites</p>
        </div>
      </div>

      <ng-template #loadingTemplate>
        <div class="text-center py-5">
          <div class="spinner-border" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>

